
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcPage from '../../blocks/PcPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { BAIDU01_DOWNLOAD_URLS, BAIDU_DOWNLOAD_CONFIGS } from '../../config/downloadUrls';
import { LandingProps } from '../../config/types';
import { setupPage } from '../../utils/setupPage';

@Component({
  components: { DeviceLayout, PcPage, MobilePage },
})
export default class Baidu01Page extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: BAIDU01_DOWNLOAD_URLS,
    hideList: false,
    showAppInfo: true,
    isBaiduDeveloper: true,
    showAddress: false,
    baiduApiToken: BAIDU_DOWNLOAD_CONFIGS.BAIDU01,
  };

  public mounted() {
    setupPage({
      documentTitle: '海南指趣互娱信息科技有限公司天津分公司',
      baiduTracking: true,
    });
  }
}
